import React, { FC, useEffect } from 'react';
import Portal from 'components/Shared/Portal';
import { BreadcrumbsStructuredDataRoot } from 'models/BreadcrumbsStructuredDataRoot';

export interface KeyValueData {
  [key: string]:
    | string
    | number
    | string[]
    | number[]
    | KeyValueData
    | KeyValueData[]
    | BreadcrumbsStructuredDataRoot[]
    | undefined;
}
interface Props {
  data: KeyValueData;
}
let element: HTMLElement | null | undefined;

const getContainer = (): HTMLElement | null => {
  if (element === undefined) {
    element = document.getElementById('sc');

    if (!element) {
      element = document.createElement('script');
      element.setAttribute('type', 'application/ld+json');
      element.setAttribute('id', 'sc');
      document.head.appendChild(element);
    }
    element.innerHTML = '';
  }

  return element;
};
const deleteElement = () => {
  if (element) {
    element = undefined;
  }
};

export const StructuredData: FC<Props> = props => {
  useEffect(
    () => () => {
      deleteElement();
    },
    []
  );

  const data = {
    '@context': 'http://schema.org/',
    ...props.data
  };

  return <Portal container={getContainer}>{JSON.stringify(data)}</Portal>;
};
